export default __webpack_public_path__ + "static/media/linkedin.e87bac1a.svg";